/**
 * @file Main site navigation component, extendable for all use cases.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MoreOptionsIcon from '../icons/MoreOptionsIcon';

class NavBar extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    togglerIcon: PropTypes.node,
    togglerChildren: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    className: PropTypes.string,
  };

  state = {
    navOpen: false,
  };

  componentDidMount() {
    if (window.document) {
      document.addEventListener('mouseup', this.onClickOutside);
    }
  }

  componentWillUnmount() {
    if (window.document) {
      document.removeEventListener('mouseup', this.onClickOutside);
    }
  }

  onClickOutside = event => {
    if (this.toggle && !this.toggle.contains(event.target)) {
      this.setState(() => ({
        navOpen: false,
      }));
    }
  };

  onNavbarTogglerClick = event => {
    event.preventDefault();

    this.setState(state => ({
      navOpen: !state.navOpen,
    }));
  };

  render() {
    const { className, children, togglerChildren, togglerIcon } = this.props;
    const { navOpen } = this.state;

    const classes = classNames({
      navbar: true,
      [className]: !!className,
      'navbar-nav-open': navOpen,
    });

    return (
      <nav className={classes}>
        {children}

        <button
          className="navbar-toggler"
          type="button"
          onClick={this.onNavbarTogglerClick}
          ref={ref => {
            this.toggle = ref;
          }}
        >
          {togglerIcon || <MoreOptionsIcon color="#0d84fe" />}
          {togglerChildren}
        </button>
      </nav>
    );
  }
}

export default NavBar;
